<template>
  <div class="event-unique-links">
    <ui-hr>已创建的unique link</ui-hr>
    <vuetable ref="vuetable" :fields="fields" :api-mode="false" :data="links" :first-page="0">
      <div slot="user" slot-scope="props">
        <ui-avatar :url="props.rowData.userInfo.avatar" :username="props.rowData.userInfo.username"></ui-avatar>
      </div>
    </vuetable>
  </div>
</template>
<script>
import Vuetable from 'vuetable-2'
import api from '../../api/index.js'
import dayjs from 'dayjs'
export default {

  name: 'event-link',

  data() {
    return {
      links: [],
      fields: [{
          name: 'user',
          title: 'Author'

        },
        {
          name: 'shortUrl',
          title: 'link'
        }, {
          name: 'created',
          formatter: (value) => {
            return this.formatDate(value)
          }
        },
        { name: 'pv', title: '浏览次数' },
      ]
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    Vuetable
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  mounted() {
    api.getEventUniqueLinks(this.id).then(res => {
      this.links = res.data.links
    }).catch(err => {

    })
  }
}

</script>
<style lang="css" scoped>
</style>
